import(/* webpackMode: "eager" */ "/srv/feelgood-dev2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/srv/feelgood-dev2/src/app/login/LoginForm.tsx");
